// schema.org BreadcrumbList JSON-LD (string, for a <script type="application/ld+json"> inside a <Helmet>).
// "Home" is always the first item; each entry after it is { name, path } with a site-relative path, and the
// last entry is the page itself. Keep the names the same as the visible breadcrumb / page heading.
const ORIGIN = "https://360synergytech.com";

export function breadcrumbSchemaJson(trail) {
  const items = [{ name: "Home", path: "/" }, ...trail];
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      item: ORIGIN + item.path,
    })),
  });
}
